import React, { useState, useEffect } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { FaMinusCircle, FaEdit, FaCheck, FaCross } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { useCategoryData } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import {
  currentSubcatOptions,
  newFAQ,
  newReason,
  newSubcategory,
  capitalizeFirstLetterOfEachWord,
  toggleFlags,
} from "modules/utilities/utility";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { Input } from "antd";

const TicketingSettings = ({ editMode, editData, setShowModal }) => {
  const [category, setCategory] = useState("");
  const [subcategories, setSubcategories] = useState([
    {
      subcategory: "",
      assignees: [""],
      subcategoryId: "",
      subcategoryKey: "",
      waba: false,
      source: "",
      faqs: [],
      faq_flag: false,
      reasons_flag: false,
      reasons: [],
      tat_limit: 0,
    },
  ]);
  const [editCategory, setEditCategory] = useState(false);
  const [editSubCategory, setEditSubCategory] = useState(false);
  const [editSubCategoryId, setEditSubCategoryId] = useState(null);
  const [updatedCategoryData, setUpdatedCategoryData] = useState("");
  const [updatedSubcategoryData, setUpdateSubcategoryData] = useState("");
  const [isCategoryValid, setIsCategoryValid] = useState(true);
  const [isSubCategoryValid, setIsSubCategoryValid] = useState(true);
  const [isAssigneeValid, setIsAssigneeValid] = useState(true);
  const {
    categorySubcatData,
    editCategoryData,
    createCategorySubcatgeory,
    deleteCategoryData,
    isLoading,
  } = useCategoryData();
  const { setToaster } = useToast();
  const [showFAQ, setShowFAQ] = useState(false);
  const [showReasons, setShowReasons] = useState(false);
  const [categoryIcon, setCategoryIcon] = useState("");
  const [crmSubcategory, setCrmSubcategory] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [subcatSelectedOptions, setSubcatSelectedOptions] = useState([]);
  const [bookCall, setBookCall] = useState(false);
  const [subCategoryValidityFlags, setSubCategoryValidityFlags] = useState(
    new Array(subcategories?.length).fill(true)
  );

  const initialAssigneeValidity = subcategories?.map((subcat) =>
    new Array(subcat?.assignees?.length).fill(true)
  );
  const [assigneeValidityFlags, setAssigneeValidityFlags] = useState(
    initialAssigneeValidity
  );
  const [isDropdownValid, setIsDropdownValid] = useState(true);
  const [categoryErrorMsg, setCategoryErrorMsg] = useState("");
  const [subCategoryErrorMsg, setSubCategoryErrorMsg] = useState("");
  const [isCustomer, setIsCustomer] = useState(false);
  const [cxsSequence, setCxsSequence] = useState();
  const [leadSequence, setLeadSequence] = useState();
  const [bookCallSequence, setBookCallSequence] = useState();
  const [categoryId, setCategoryId] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteType, setDeleteType] = useState(null);
  const [subcatDeleteData, setSubcatDeleteData] = useState(null);
  const [isInternal, setIsInternal] = useState(false);

  useEffect(() => {
    if (editMode && editData) {
      setCategory(editData?.category?.label);
      setCategoryId(editData?.category?.value);
      const transformedData = editData?.category?.source?.map((sourceItem) => ({
        label: sourceItem,
        value: sourceItem,
      }));
      //   setSelectedSource(transformedData);
      setSelectedOptions(transformedData);
      setCategoryIcon(editData?.category?.categoryIcon);
      setBookCall(editData?.category?.showBookCall);
      setIsCustomer(editData?.category?.customerVisible);
      setCxsSequence(editData?.category?.customerSeq);
      setLeadSequence(editData?.category?.leadSeq);
      setBookCallSequence(editData?.category?.bookCallSeq);
      setSubcategories(
        editData?.subcategories?.map((subcategory) => {
          return {
            name: subcategory?.label,
            id: subcategory?.value,
            assignees: subcategory?.assigneeDetail,
            waba: subcategory?.waba,
            faq_flag: subcategory?.faq_flag,
            faqs: subcategory?.faqs.map((faq) => {
              const { assigneeDetail, ...rest } = faq;
              return {
                ...rest,
                assignees: assigneeDetail,
              };
            }),
            reasons_flag: subcategory?.reasons_flag,
            reasons: subcategory?.reasons,
            source: subcategory?.source,
            showBookCall: subcategory?.showBookCall,
            customerVisbile: subcategory?.customerVisible,
            crmVisible: subcategory?.crmVisible,
            tat_limit: subcategory?.tat_limit || 0,
            disabled_tooltip: subcategory?.disabled_tooltip,
            enabled_tooltip: subcategory?.enabled_tooltip
          }
        })
      );
      const transformedSubcatSources = editData?.subcategories?.map(
        (subcategory) =>
          subcategory?.source?.map((sourceItem) => ({
            label: sourceItem,
            value: sourceItem,
          }))
      );
      // Initialize assignee validity flags based on the loaded data
      const initialAssigneeValidity = editData?.subcategories?.map(
        (subcategory) =>
          new Array(subcategory.assigneeDetail?.length).fill(true)
      );
      setAssigneeValidityFlags(initialAssigneeValidity);

      // Initialize subcategory validity flags based on the loaded data
      const initialSubCategoryValidity = new Array(
        editData?.subcategories?.length
      ).fill(true);
      setSubCategoryValidityFlags(initialSubCategoryValidity);

      // Set dropdown validity to true
      setIsDropdownValid(true);
      setIsInternal(editData?.category?.is_internal);
    }
  }, [editMode, editData]);

  const addItemToSubcategory = (subcategoryIndex, key, newItem) => {
    const updatedSubcategories = [...subcategories];
    if (!updatedSubcategories[subcategoryIndex][key]) {
      updatedSubcategories[subcategoryIndex][key] = [];
    }
    updatedSubcategories[subcategoryIndex][key].push(newItem);
    setSubcategories(updatedSubcategories);
  };

  const handleAddSubcategory = () => {
    const newSubcat = newSubcategory();
    setSubcategories((prev) => {
      if (prev == null) {
        return [newSubcat];
      } else {
        return [...prev, newSubcat];
      }
    });

    // Also update the assigneeValidityFlags
    setAssigneeValidityFlags((prev) => {
      if (prev == null) {
        return [new Array(newSubcat.assignees.length).fill(true)];
      } else {
        return [...prev, new Array(newSubcat.assignees.length).fill(true)];
      }
    });
  };

  const handleAddAssignee = (subcategoryIndex) => {
    const lastAssignee = subcategories[subcategoryIndex].assignees.slice(-1)[0];
    if (lastAssignee === "") {
      return;
    }
    addItemToSubcategory(subcategoryIndex, "assignees", "");
  };

  const handleAddFAQ = (subcategoryIndex) => {
    addItemToSubcategory(subcategoryIndex, "faqs", newFAQ());
  };

  const handleAddReason = (subcategoryIndex) => {
    addItemToSubcategory(subcategoryIndex, "reasons", newReason());
  };

  const handleAddImageLink = (subcategoryIndex, faqIndex) => {
    const updatedSubcategories = [...subcategories];
    const lastLink =
      subcategories[subcategoryIndex]?.faqs[
        faqIndex
      ]?.banner_image_cdn_link?.slice(-1)[0];
    if (lastLink === "") {
      return;
    }
    if (
      !updatedSubcategories[subcategoryIndex]?.faqs[faqIndex]
        ?.banner_image_cdn_link
    ) {
      updatedSubcategories[subcategoryIndex].faqs[
        faqIndex
      ].banner_image_cdn_link = [];
    }
    updatedSubcategories[subcategoryIndex].faqs[
      faqIndex
    ]?.banner_image_cdn_link.push("");
    setSubcategories(updatedSubcategories);
  };

  const handleDelete = (type, subcategoryIndex, itemIndex = null) => {
    const updatedSubcategories = [...subcategories];

    switch (type) {
      case "reason":
        updatedSubcategories[subcategoryIndex].reasons.splice(itemIndex, 1);
        break;
      case "faq":
        updatedSubcategories[subcategoryIndex].faqs.splice(itemIndex, 1);
        break;
      case "subcategory":
        updatedSubcategories.splice(subcategoryIndex, 1);
        reinitializeAssigneeValidityFlags();
        break;
      case "assignee":
        updatedSubcategories[subcategoryIndex].assignees.splice(itemIndex, 1);
        reinitializeAssigneeValidityFlags();
        break;
      default:
      // console.error("Unknown deletion type");
    }

    setSubcategories(updatedSubcategories);
  };

  const DeleteButton = ({
    type,
    subcategoryIndex,
    itemIndex = null,
    className = "",
  }) => {
    return (
      editMode === false && (
        <Button
          variant="link"
          onClick={() => handleDelete(type, subcategoryIndex, itemIndex)}
          className={`text-danger ${className}`}
        >
          <FaMinusCircle />
        </Button>
      )
    );
  };

  const handleSubmit = async () => {
    const categoryKey = category.toLowerCase().split(" ").join("_");
    const categorySource = selectedOptions.map((option) => option.value);
    const payload = {
      category,
      categoryKey,
      categoryIcon,
      showBookCall: bookCall,
      customerVisible: isCustomer,
      customerSeq: cxsSequence || 0,
      leadSeq: leadSequence || 0,
      bookCallSeq: bookCallSequence || 0,
      subcategories,
      categorySource,
      isInternal,
    };
    setShowModal(false);
    await createCategorySubcatgeory(payload, setToaster);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const prepareEditCategory = (categoryData) => {
    if (!editCategory) {
      const updatedData = {
        id: editData?.category?.value,
        name: category,
        parent_cateogry_id: null, // Typo: Should it be parent_category_id?
        showBookCall: bookCall,
        customerVisible: isCustomer,
      };
      setUpdatedCategoryData(updatedData);
      setEditCategory(true);
    } else {
      const temp = {
        ...updatedCategoryData,
        name: category,
        categoryIcon: categoryIcon,
        showBookCall: bookCall,
        customerVisible: isCustomer,
        customerSeq: cxsSequence,
        leadSeq: leadSequence,
        bookCallSeq: bookCallSequence,
        isInternal: isInternal,
      };

      const sourceValues = selectedOptions.map((option) => option.value);

      if (sourceValues.length > 0) {
        temp.source = sourceValues;
      }

      editCategoryData(temp, setToaster);
      setEditCategory(false);
      console.log("Category data has not been updated, skipping API call");
    }
  };

  const handleEditButtonClicked = ({ id, ...rest }) => {
    setEditSubCategoryId(id);
    setUpdateSubcategoryData({
      ...rest,
      parent_cateogry_id: editData?.categoryId,
      source: rest?.subCategorySource,
    });
  };

  const handleCheckButtonClicked = async ({ subcategory, assignees, faqs, ...rest }) => {
    setEditSubCategory(false);
    setEditSubCategoryId(null);

    const _assignee = assignees.filter(Boolean).map((assignee) => {
      if (typeof assignee === "object" && assignee.email) {
        return assignee.email;
      } else if (typeof assignee === "string") {
        return assignee;
      }
      // Handle other cases if needed
      return assignee;
    });

    const _faqs = faqs.map((faq) => {
      const { assignees, ...restFaq } = faq;
      const _assignees = assignees?.map((assignee) => {
        if (typeof assignee === "object" && assignee?.email) {
          return assignee?.email;
        } else if (typeof assignee === "string") {
          return assignee;
        }
        // Handle other cases if needed
        return assignee;
      });

      return {
        ...restFaq,
        assignees: _assignees, // Rename assigneeDetail to assignees
      };
    });

    const temp = {
      id: updatedSubcategoryData?.id,
      parent_cateogry_id: updatedSubcategoryData?.parent_cateogry_id,
      subcategory,
      assignees: _assignee,
      faqs: _faqs, // Replace faqs with the modified version
      ...rest,
    };

    await editCategoryData(temp, setToaster);
    // setShowModal(false);
  };

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const handleSource = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };

  const handleSubcatSourceChange = (selectedOptions, subcategoryIndex) => {
    const updatedOptions = [...subcatSelectedOptions];
    updatedOptions[subcategoryIndex] = selectedOptions;
    setSubcatSelectedOptions(updatedOptions);

    // Update subcategories state if needed
    const selectedValues = selectedOptions.map((option) => option.value);
    const updatedSubcategories = subcategories.map((subcategory, index) => {
      if (index !== subcategoryIndex) return subcategory;
      return { ...subcategory, source: selectedValues };
    });
    setSubcategories(updatedSubcategories);
  };
  /* 
   1. Initialize an array to store the filtered and mapped results
   2. Loop through the "category" array data
   3. Check if the "source" array in the category item includes any of the filtered sources
   4. Find the subcategory items associated with this category item
   5. Map the subcategory items to get the desired information
   6. Add the mapped subcategory items to the result array
   */
  useEffect(() => {
    const filteredSources = ["CRM"];
    const filteredAndMappedData = [];
    categorySubcatData?.data?.category?.forEach((categoryItem) => {
      if (
        filteredSources.some((source) => categoryItem.source.includes(source))
      ) {
        const subcategoryItems =
          categorySubcatData?.data?.subcategory[categoryItem.value];
        if (subcategoryItems) {
          const mappedSubcategoryItems = subcategoryItems?.map(
            (subcategoryItem) => ({
              label: subcategoryItem.label,
              value: subcategoryItem.key,
            })
          );
          filteredAndMappedData.push(...mappedSubcategoryItems);
        }
      }
    });
    setCrmSubcategory(filteredAndMappedData);
  }, [categorySubcatData]);

  const handleCrmSubcategory = (selectedOption, subcategoryIndex, faqIndex) => {
    const value = selectedOption;
    const updatedSubcategories = [...subcategories];
    updatedSubcategories[subcategoryIndex].faqs[faqIndex]["faq_key"] = value;
    setSubcategories(updatedSubcategories);
  };

  const hasSpecialChars = (str) => /[!@#$%^*_+\-=\[\]{};:"\\|,.<>\/?]+/.test(str);
  const hasNumbers = (str) => /\d/.test(str);
  const isValidEmail = (str) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
  const formatStringToKey = (str) => str.toLowerCase().split(" ").join("_");

  const handleChange = (type, event, subcategoryIndex, itemIndex) => {
    const inputValue = event?.target?.value;
    const updatedSubcategories = [...subcategories];
    const updatedSubCatValidityFlags = [...subCategoryValidityFlags];
    const updatedAssigneeValidityFlags = [...assigneeValidityFlags];
    switch (type) {
      case "faq": updatedSubcategories[subcategoryIndex].faqs[itemIndex].display_name = inputValue;
        break;
      case "reason": updatedSubcategories[subcategoryIndex].reasons[itemIndex] = { label: inputValue, value: formatStringToKey(inputValue) };
        break;
      case "subcategory":
        const formattedSubcat = capitalizeFirstLetterOfEachWord(inputValue);
        if (formattedSubcat.length < 4) {
          updatedSubCatValidityFlags[subcategoryIndex] = false;
          setSubCategoryErrorMsg("Subcategory should have at least 4 characters.");
        } else if (!hasSpecialChars(formattedSubcat) && !hasNumbers(formattedSubcat)) {
          const allSubcategories = Object.values(categorySubcatData?.data?.subcategory || {}).flat();
          const isDuplicate = allSubcategories.some((item) => item.label === formattedSubcat);

          if (isDuplicate) {
            updatedSubCatValidityFlags[subcategoryIndex] = false;
            setSubCategoryErrorMsg("Subcategory name already used");
          } else {
            updatedSubcategories[subcategoryIndex].subcategory = formattedSubcat;
            updatedSubcategories[subcategoryIndex].subcategoryKey = formatStringToKey(formattedSubcat);
            updatedSubCatValidityFlags[subcategoryIndex] = true;
            setSubCategoryErrorMsg("");
          }
        } else {
          updatedSubCatValidityFlags[subcategoryIndex] = false;
          setSubCategoryErrorMsg("Please enter a valid Subcategory (only letters allowed).");
        }
        setSubCategoryValidityFlags(updatedSubCatValidityFlags);
        break;

      case "assignee":
        const currentAssignees = [...updatedSubcategories[subcategoryIndex].assignees,];
        currentAssignees[itemIndex] = inputValue;
        if (currentAssignees.filter((email) => email === inputValue).length > 1) {
          updatedAssigneeValidityFlags[subcategoryIndex][itemIndex] = "duplicate";
        } else {
          updatedAssigneeValidityFlags[subcategoryIndex][itemIndex] = isValidEmail(inputValue);
        }
        updatedSubcategories[subcategoryIndex].assignees[itemIndex] = inputValue;
        setAssigneeValidityFlags(updatedAssigneeValidityFlags);
        break;
      case "category":
        const formattedCategory = capitalizeFirstLetterOfEachWord(inputValue);
        setCategory(formattedCategory);

        if (formattedCategory.length < 4) {
          setCategoryErrorMsg("Category name must have at least 4 characters.");
          setIsCategoryValid(false);
        } else if (!hasSpecialChars(inputValue) && !hasNumbers(inputValue)) {
          const duplicate = categorySubcatData?.data?.category.some((cat) => cat.label === formattedCategory);

          if (duplicate) {
            setCategoryErrorMsg("Category name already used");
            setIsCategoryValid(false);
          } else {
            setCategoryErrorMsg(""); // Clear previous error message
            setIsCategoryValid(true);
          }
        } else {
          setCategoryErrorMsg("Please enter a valid category (only letters allowed).");
          setIsCategoryValid(false);
        }
        break;
      case "isInternalCheckbox": setIsInternal(event?.target?.checked);
        break;
      case "subcategoryTat": updatedSubcategories[subcategoryIndex].tat_limit = Number(inputValue);
        break;
      default: break;
    }

    setSubcategories(updatedSubcategories);
  };

  const reinitializeAssigneeValidityFlags = () => {
    const newValidityFlags = subcategories.map((subcat) =>
      new Array(subcat.assignees.length).fill(true)
    );
    setAssigneeValidityFlags(newValidityFlags);
  };

  const allAssigneesValid = assigneeValidityFlags?.every((subcatFlags) => subcatFlags?.every((valid) => valid) === true)
    && !subcategories.some((subcat) => subcat?.assignees.includes(""));

  const allSubCategoriesValid = subCategoryValidityFlags?.every((valid) => valid);

  const isFormValid = isCategoryValid && allAssigneesValid && allSubCategoriesValid && category !== "";

  const checkDropdownValidity = () => {
    for (let subcategory of subcategories) {
      for (let faq of subcategory.faqs) {
        if (faq.ticket_flag && !faq.faq_key) {
          setIsDropdownValid(false);
          return;
        }
      }
    }
    setIsDropdownValid(true);
  };

  const isDuplicatePresent = assigneeValidityFlags?.some((flags) => flags.includes("duplicate"));

  const handleCategoryButtonClick = () => {
    setDeleteType("category");
    setShowConfirmation(true);
  };

  const handleSubcatButtonClick = (subcategory) => {
    const payload = {
      id: subcategory?.id,
      parent_category_id: categoryId,
      type: "subcategory",
    };
    setDeleteType("subcategory");
    setSubcatDeleteData(payload);
    setShowConfirmation(true);
  };

  const handleDeleteAssignee = (assignee, subcategory) => {
    const assigneeId = assignee?._id;
    const payload = {
      id: subcategory?.id,
      parent_category_id: categoryId,
      type: "assignee",
      assignee: assigneeId,
    };
    setDeleteType("assignee");
    setSubcatDeleteData(payload);
    setShowConfirmation(true);
  };

  const handleDeleteFaq = (faq, subcategory) => {
    const faqId = faq?._id;
    const payload = {
      id: subcategory?.id,
      parent_category_id: categoryId,
      type: "faq",
      faq: faqId,
    };
    setDeleteType("faq");
    setSubcatDeleteData(payload);
    setShowConfirmation(true);
  };

  const handleDeleteReasons = (reason, subcategory) => {
    const reasonId = reason._id;
    const payload = {
      id: subcategory?.id,
      parent_category_id: categoryId,
      type: "reason",
      reason: reasonId,
    };
    setDeleteType("reason");
    setSubcatDeleteData(payload);
    setShowConfirmation(true);
  };

  const handleConfirmDelete = async () => {
    if (deleteType === "category") {
      const payload = {
        id: categoryId,
        parent_category_id: null,
        type: "category",
      };
      await deleteCategoryData(payload, setToaster);
      setShowModal(false);
    } else {
      if (subcatDeleteData) {
        await deleteCategoryData(subcatDeleteData, setToaster);
        setShowModal(false);
      }
    }
    setShowConfirmation(false);
    setDeleteType(null);
  };

  const handleFAQAssigneeChange = (event, subcategoryIndex, faqIndex, assigneeIndex) => {
    const inputValue = event?.target?.value;
    const updatedSubcategories = [...subcategories];
    if (isValidEmail(inputValue)) {
      updatedSubcategories[subcategoryIndex].faqs[faqIndex].assignees[assigneeIndex] = inputValue;
      setSubcategories(updatedSubcategories);
    }
  };

  const handleFAQDeleteAssignee = (assignees, subcategoryIndex, faqIndex, assigneeIndex) => {
    const updatedSubcategories = [...subcategories];
    updatedSubcategories[subcategoryIndex].faqs[faqIndex].assignees.splice(assigneeIndex, 1);
    setSubcategories(updatedSubcategories);
  };

  const handleFAQAddAssignee = (subcategoryIndex, faqIndex) => {
    const updatedSubcategories = [...subcategories];
    if (!updatedSubcategories[subcategoryIndex].faqs[faqIndex].assignees) {
      updatedSubcategories[subcategoryIndex].faqs[faqIndex].assignees = [];
    }
    updatedSubcategories[subcategoryIndex].faqs[faqIndex].assignees.push("");
    setSubcategories(updatedSubcategories);
  };

  return (
    <div className="container mt-3">
      <Form>
        <div className="mb-3 p-3 border">
          <div className="top-class">
            <Form.Group controlId="category">
              <div className="border rounded d-flex gap-3 shadow mb-5">
                <div className="w-100">
                  <div className="p-3 d-flex justify-content-end">
                    <div>
                      {editMode && (
                        <Button
                          variant="warning"
                          onClick={() => prepareEditCategory(category)}
                          disabled={!isCategoryValid || !isSubCategoryValid || !isAssigneeValid}
                        >
                          {editCategory ? "Submit" : "Edit Category"}
                        </Button>
                      )}
                      {editMode && (
                        <>
                          <Button
                            variant="danger"
                            onClick={handleCategoryButtonClick}
                            disabled={!isCategoryValid || !isSubCategoryValid || !isAssigneeValid}
                          >
                            Delete Category
                          </Button>
                          <Modal
                            show={showConfirmation}
                            onHide={() => setShowConfirmation(false)}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Confirm Deletion</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              Are you sure you want to delete this {deleteType}?
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                onClick={() => setShowConfirmation(false)}
                              >
                                Cancel
                              </Button>
                              <Button
                                variant="danger"
                                onClick={handleConfirmDelete}
                              >
                                Confirm Delete
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between flex-wrap w-100">
                    <div className="col-md-3 p-3">
                      <div className="mb-4">
                        <h5 className="mb-3">Category</h5>

                        <div className="">
                          <Form.Control
                            className="mr-2 flex-grow-1"
                            type="text"
                            placeholder="Category"
                            value={category}
                            onChange={(event) => handleChange("category", event)}
                            isInvalid={!isCategoryValid}
                            disabled={editMode === true && editCategory === false}
                          />
                          <Form.Control.Feedback type="invalid">
                            {categoryErrorMsg}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 p-3">
                      <Form.Group className="mb-4">
                        <h5 className="mb-3">Category Icon CDN Link</h5>
                        <Form.Control
                          type="text"
                          placeholder="CDN Link"
                          defaultValue={categoryIcon || ""}
                          onChange={(event) => { setCategoryIcon(event.target.value); }}
                          disabled={!editCategory && editMode}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-3 p-3">
                      <h5 className="mb-2">Category Source</h5>
                      <div className="mb-4">
                        <ReactSelect
                          options={currentSubcatOptions}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{ Option }}
                          onChange={handleSource}
                          value={selectedOptions}
                          isDisabled={!editCategory && editMode}
                        />
                      </div>
                    </div>
                    <div className="col-md-2 p-3">
                      <h5 className="mb-2">Show Book a call</h5>
                      <Form.Check
                        type="switch"
                        //   id={`toggle-${subcategoryIndex}`}
                        label={bookCall ? "On" : "Off"}
                        checked={bookCall}
                        onChange={() => { setBookCall(!bookCall); }}
                        disabled={!editCategory && editMode}
                      />
                    </div>

                    <div className="col-md-2 p-3">
                      <h5 className="mb-2">Internal Category</h5>
                      <Form.Check
                        type="switch"
                        label={isInternal ? "Yes" : "No"}
                        checked={isInternal}
                        onChange={(event) => handleChange("isInternalCheckbox", event)}
                        disabled={!editCategory && editMode}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between w-100">
                    <div className="col-md-3 p-3">
                      <h5 className="mb-2">Customer Visible</h5>
                      <Form.Check
                        type="switch"
                        //   id={`toggle-${subcategoryIndex}`}
                        label={isCustomer ? "On" : "Off"}
                        checked={isCustomer}
                        onChange={() => { setIsCustomer(!isCustomer); }}
                        disabled={!editCategory && editMode}
                      />
                    </div>
                    <div className="col-md-3 p-3">
                      <Form.Group className="mb-4">
                        <h5 className="mb-3">Customer Sequence</h5>
                        <Form.Control
                          type="number"
                          placeholder="Enter number"
                          defaultValue={cxsSequence || ""}
                          onChange={(event) => { setCxsSequence(Number(event.target.value)); }}
                          pattern="\d+"
                          disabled={!editCategory && editMode}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-3 p-3">
                      <Form.Group className="mb-4">
                        <h5 className="mb-3">Lead Sequence</h5>
                        <Form.Control
                          type="number"
                          placeholder="Enter number"
                          defaultValue={leadSequence || ""}
                          onChange={(event) => { setLeadSequence(Number(event.target.value)); }}
                          pattern="\d+"
                          disabled={!editCategory && editMode}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-3 p-3">
                      <Form.Group className="mb-4">
                        <h5 className="mb-3">Book a call Sequence</h5>
                        <Form.Control
                          type="number"
                          placeholder="Enter number"
                          defaultValue={bookCallSequence || ""}
                          onChange={(event) => { setBookCallSequence(Number(event.target.value)); }}
                          pattern="\d+"
                          disabled={!editCategory && editMode}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>
            </Form.Group>
          </div>

          <div>
            {subcategories?.map((subcategory, subcategoryIndex) => (
              <div className="border rounded d-flex gap-3 shadow mb-4">
                <div key={subcategoryIndex} className="w-100">
                  <div className="p-3 d-flex justify-content-end">
                    {editMode === true &&
                      (editSubCategoryId !== subcategory.id ? (
                        <Button
                          variant="warning"
                          className="mx-2"
                          onClick={() => handleEditButtonClicked(subcategory)}
                        >
                          Edit Subcategory {subcategoryIndex + 1}
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          className="mx-2"
                          onClick={() => handleCheckButtonClicked(subcategory)}
                          disabled={!isFormValid || !isDropdownValid || !subCategoryValidityFlags.every((flag) => flag) || isDuplicatePresent}
                        >
                          Submit
                        </Button>
                      ))}
                    {editMode && (
                      <>
                        <Button
                          variant="danger"
                          onClick={() => handleSubcatButtonClick(subcategory)}
                          disabled={!isCategoryValid || !isSubCategoryValid || !isAssigneeValid}
                        >
                          Delete Subcategory
                        </Button>
                      </>
                    )}
                  </div>
                  <Form.Group controlId={subcategory.id}>
                    <div className="d-flex justify-content-between flex-wrap">
                      <div className="col-md-3 p-3">
                        <div className="mb-4">
                          <h5>{subcategoryIndex + 1}. Subcategory</h5>
                          <div className="d-flex">
                            <div
                              style={{ display: "flex", flexDirection: "column" }}
                            >
                              <Form.Control
                                type="text"
                                placeholder="Subcategory"
                                defaultValue={subcategory?.name}
                                onChange={(event) => handleChange("subcategory", event, subcategoryIndex)}
                                isInvalid={!subCategoryValidityFlags[subcategoryIndex]}
                                disabled={editMode === true && editSubCategoryId !== subcategory.id}
                              />
                              <Form.Control.Feedback type="invalid">
                                {subCategoryErrorMsg}
                              </Form.Control.Feedback>
                            </div>
                            {editMode === true && (
                              <DeleteButton
                                type="subcategory"
                                subcategoryIndex={subcategoryIndex}
                                className="d-flex"
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3 p-3">
                        <div className="mb-4">
                          <h5>Subcategory Source</h5>
                          <div className="d-flex align-items-center">
                            <ReactSelect
                              options={currentSubcatOptions}
                              isMulti
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              components={{ Option }}
                              onChange={(selectedOptions) => handleSubcatSourceChange(selectedOptions, subcategoryIndex)}
                              className="w-100"
                              isDisabled={editMode === true && editSubCategoryId !== subcategory.id}
                              value={subcatSelectedOptions[subcategoryIndex]}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-2 p-3">
                        {
                          <div className="mb-2">
                            <h5>WABA</h5>
                            <Form.Check
                              type="switch"
                              id={`toggle-${subcategoryIndex}`}
                              label={subcategory.waba ? "On" : "Off"}
                              checked={subcategory.waba}
                              onChange={() => {
                                const updatedSubcategories = [...subcategories];
                                updatedSubcategories[subcategoryIndex].waba = !updatedSubcategories[subcategoryIndex].waba;
                                setSubcategories(updatedSubcategories);
                              }}
                              disabled={editMode === true && editSubCategoryId !== subcategory.id}
                            />
                          </div>
                        }
                      </div>

                      <div className="col-md-2 p-3">
                        {
                          <div className="mb-2">
                            <h5>Show Book a call</h5>
                            <Form.Check
                              type="switch"
                              id={`call-${subcategoryIndex}`}
                              label={subcategory?.showBookCall ? "On" : "Off"}
                              checked={subcategory?.showBookCall}
                              onChange={() => {
                                const updatedSubcategories = [...subcategories];
                                updatedSubcategories[subcategoryIndex].showBookCall = !updatedSubcategories[subcategoryIndex].showBookCall;
                                setSubcategories(updatedSubcategories);
                              }}
                              disabled={editMode === true && editSubCategoryId !== subcategory.id}
                            />
                          </div>
                        }
                      </div>

                      <div className="col-md-2 p-3">
                        {
                          <div className="mb-2">
                            <h5>Customer Visible</h5>
                            <Form.Check
                              type="switch"
                              id={`call-${subcategoryIndex}`}
                              label={
                                subcategory?.customerVisbile ? "On" : "Off"
                              }
                              checked={subcategory?.customerVisbile}
                              onChange={() => {
                                const updatedSubcategories = [...subcategories];
                                updatedSubcategories[subcategoryIndex].customerVisbile = !updatedSubcategories[subcategoryIndex].customerVisbile;
                                setSubcategories(updatedSubcategories);
                              }}
                              disabled={editMode === true && editSubCategoryId !== subcategory.id}
                            />
                          </div>
                        }
                      </div>
                      <div className="col-md-2 p-3">
                        <div className="mb-2">
                          <h5>CRM Visible</h5>
                          <Form.Check
                            type="switch"
                            id={`call-${subcategoryIndex}`}
                            label={subcategory?.crmVisible ? "On" : "Off"}
                            checked={subcategory?.crmVisible}
                            onChange={() => {
                              const updatedSubcategories = [...subcategories];
                              updatedSubcategories[subcategoryIndex].crmVisible = !updatedSubcategories[subcategoryIndex].crmVisible;
                              setSubcategories(updatedSubcategories);
                            }}
                            disabled={editMode === true && editSubCategoryId !== subcategory.id}
                          />
                        </div>
                      </div>
                      <div className="flex-fill p-3">
                        <div className="mb-2">
                          <h5>Enabled Tooltip</h5>
                          <Input placeholder="Enter Tooltip if enabled" allowClear 
                          value={subcategory.enabled_tooltip||'nahi he'}
                          onChange={(event) => {
                            const { value } = event.target;
                            const updatedSubcategories = [...subcategories];
                            updatedSubcategories[subcategoryIndex].enabled_tooltip = value;
                            setSubcategories(updatedSubcategories);
                          }}
                          disabled={editMode === true && editSubCategoryId !== subcategory.id}/>
                        </div>
                      </div>
                      <div className="flex-fill p-3">
                        <div className="mb-2">
                          <h5>Disabled Tooltip</h5>
                          <Input placeholder="Enter Tooltip if disabled" allowClear 
                          value={subcategory.disabled_tooltip}
                          onChange={(event) => {
                            const { value } = event.target;
                            const updatedSubcategories = [...subcategories];
                            updatedSubcategories[subcategoryIndex].disabled_tooltip = value;
                            setSubcategories(updatedSubcategories);
                          }}
                          disabled={editMode === true && editSubCategoryId !== subcategory.id}/>
                        </div>
                      </div>
                    </div>
                  </Form.Group>
                  <div className="d-flex justtify-content-between">
                    <div className="tatLimit d-flex align-item-center justify-content-between col-md-1 p-3">
                      <div>
                        <Form.Label>TAT(Hours)</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Add Tat In Hours"
                          value={subcategory?.tat_limit || 0}
                          onChange={(event) => handleChange("subcategoryTat", event, subcategoryIndex)}
                          isInvalid={!subCategoryValidityFlags[subcategoryIndex]}
                          disabled={editMode === true && editSubCategoryId !== subcategory.id}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="w-100 p-3">
                      <div className="mb-4">
                        <h5 className="mb-3">Assignee</h5>
                        <div className="row">
                          {subcategory.assignees.map(
                            (assignee, assigneeIndex) => (
                              <div
                                className="col-md-4 mb-3"
                                key={assigneeIndex}
                              >
                                <Form.Group>
                                  <div className="d-flex">
                                    <div style={{ display: "flex", flexDirection: "column" }}
                                    >
                                      <Form.Control
                                        type="text"
                                        placeholder="Assignees"
                                        value={assignee?.email}
                                        onChange={(event) => handleChange("assignee", event, subcategoryIndex, assigneeIndex)}
                                        isInvalid={!assigneeValidityFlags[subcategoryIndex]?.[assigneeIndex] || assigneeValidityFlags[subcategoryIndex]?.[assigneeIndex] === "duplicate"}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        {assigneeValidityFlags[subcategoryIndex]?.[assigneeIndex] === "duplicate" ? "Email already used in this subcategory" : "Please enter a valid email."}
                                      </Form.Control.Feedback>
                                    </div>
                                    {editMode === false && (
                                      <DeleteButton
                                        type="assignee"
                                        subcategoryIndex={subcategoryIndex}
                                        itemIndex={assigneeIndex}
                                        className="d-flex"
                                      />
                                    )}
                                    {editMode && (
                                      <>
                                        <Button
                                          variant="danger"
                                          onClick={() => handleDeleteAssignee(assignee, subcategory)}
                                          disabled={!isCategoryValid || !isSubCategoryValid || !isAssigneeValid}
                                        >
                                          <FaMinusCircle />
                                        </Button>
                                      </>
                                    )}
                                    {/* Assuming there's more JSX for assignees */}
                                  </div>
                                </Form.Group>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                      <Button
                        variant="success"
                        onClick={() => handleAddAssignee(subcategoryIndex)}
                        className="mt-2"
                        disabled={editMode === true && editSubCategoryId !== subcategory.id}
                      >
                        + Assignee
                      </Button>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <h5 className="p-3">Enable FAQ</h5>
                    <div className="p-3">
                      <Form.Check
                        type="switch"
                        id="faq-toggle"
                        checked={subcategory?.faq_flag}
                        onChange={() => {
                          const newShowFAQ = !showFAQ;
                          setShowFAQ(newShowFAQ);
                          const updatedSubcategories = [...subcategories];
                          updatedSubcategories[subcategoryIndex].faq_flag = newShowFAQ;
                          setSubcategories(updatedSubcategories);
                        }}
                        disabled={editMode === true && editSubCategoryId !== subcategory.id}
                      />
                    </div>
                  </div>

                  {(showFAQ || subcategory?.faq_flag) && (
                    <>
                      {subcategory?.faqs?.map((faq, faqIndex) => (
                        <>
                          <div key={faqIndex}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}
                            >
                              <div>
                                <h5 className="mb-3 ml-4 p-3">
                                  FAQ {faqIndex + 1} Details
                                </h5>
                              </div>
                              <div className="mb-3 ml-4 p-3">
                                {editMode && (
                                  <>
                                    <Button
                                      variant="danger"
                                      onClick={() => handleDeleteFaq(faq, subcategory)}
                                      disabled={!isCategoryValid || !isSubCategoryValid || !isAssigneeValid}
                                    >
                                      Delete FAQ
                                    </Button>
                                  </>
                                )}
                              </div>
                            </div>

                            <div className="col-md-2 p-3">
                              <Form.Label>Display Name</Form.Label>
                            </div>
                            <div className="row align-items-center mb-3 p-3">
                              <div className="col-md-9 p-3">
                                <Form.Control
                                  type="text"
                                  defaultValue={faq.display_name}
                                  onChange={(event) => handleChange("faq", event, subcategoryIndex, faqIndex)}
                                  disabled={editMode === true && editSubCategoryId !== subcategory.id}
                                />
                              </div>

                              <div className="col-md-1">
                                {editMode === false && (
                                  <DeleteButton
                                    type="faq"
                                    subcategoryIndex={subcategoryIndex}
                                    itemIndex={faqIndex}
                                  />
                                )}
                              </div>
                              <div className="col-md-3 p-3">
                                <ReactSelect
                                  options={crmSubcategory}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  onChange={(selectedOptions) => {
                                    handleCrmSubcategory(selectedOptions, subcategoryIndex, faqIndex);
                                    checkDropdownValidity();
                                  }}
                                  isDisabled={editMode === true && editSubCategoryId !== subcategory.id}
                                  value={faq?.faq_key}
                                  placeholder={"Map CRM subcategory"}
                                />
                                {!isDropdownValid && (
                                  <div className="text-danger">
                                    Please fill out the CRM subcategory when
                                    Ticket Flag is active.
                                  </div>
                                )}
                              </div>
                              {/* Delete Button */}
                            </div>
                            {/* FAQ Answer */}
                            <div className="mt-2 p-3">
                              <Form.Label>FAQ Answer</Form.Label>
                              <Form.Control
                                as="textarea"
                                placeholder="FAQ Answer"
                                defaultValue={faq?.faq_ans || ""}
                                onChange={(event) => {
                                  const updatedSubcategories = [...subcategories];
                                  if (!updatedSubcategories[subcategoryIndex].faqs) { updatedSubcategories[subcategoryIndex].faqs = []; }
                                  updatedSubcategories[subcategoryIndex].faqs[faqIndex] = { ...updatedSubcategories[subcategoryIndex].faqs[faqIndex], faq_ans: event.target.value };
                                  setSubcategories(updatedSubcategories);
                                }}
                                rows={5} // You can set the number of rows here
                                disabled={editMode === true && editSubCategoryId !== subcategory.id}
                              />
                            </div>
                            {/* Banner Image CDN Link */}
                            <div className="mt-2 p-3">
                              {faq?.banner_image_cdn_link?.map(
                                (link, linkIndex) => (
                                  <div key={linkIndex} className="mb-3">
                                    <Form.Label>
                                      Banner Image CDN Link
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      placeholder="Banner Image CDN Link"
                                      defaultValue={link || ""}
                                      onChange={(event) => {
                                        const updatedSubcategories = [...subcategories];
                                        updatedSubcategories[subcategoryIndex].faqs[faqIndex].banner_image_cdn_link[linkIndex] = event.target.value;
                                        setSubcategories(updatedSubcategories);
                                      }}
                                      disabled={editMode === true && editSubCategoryId !== subcategory.id}
                                    />
                                  </div>
                                )
                              )}
                              <Button
                                variant="success"
                                onClick={() => handleAddImageLink(subcategoryIndex, faqIndex)}
                                className="mt-2"
                                disabled={editMode === true && editSubCategoryId !== subcategory.id}
                              >
                                Add Image Link
                              </Button>
                            </div>

                            {/* Banner Video Link */}
                            <div className="mt-2 p-3">
                              <Form.Label>Banner Video Link</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Banner Video Link"
                                defaultValue={faq?.banner_video_link || ""}
                                onChange={(event) => {
                                  const updatedSubcategories = [...subcategories,];
                                  updatedSubcategories[subcategoryIndex].faqs[faqIndex] = { ...updatedSubcategories[subcategoryIndex].faqs[faqIndex], banner_video_link: event.target.value };
                                  setSubcategories(updatedSubcategories);
                                }}
                                disabled={editMode === true && editSubCategoryId !== subcategory.id}
                              />
                            </div>

                            <div className="row p-3">
                              {toggleFlags?.map((flag, index) => (
                                <div key={index} className="col-md-4 mb-2">
                                  <div className="d-flex justify-content-center">
                                    <div className="w-50">
                                      <Form.Label className="fs-0">
                                        {flag.label}
                                      </Form.Label>
                                      <Form.Check
                                        type="switch"
                                        id={`toggle-${flag.key}-${faqIndex}`}
                                        label={faq[flag.key] ? "On" : "Off"}
                                        checked={faq[flag.key]}
                                        onChange={() => {
                                          const updatedSubcategories = [...subcategories];
                                          updatedSubcategories[subcategoryIndex].faqs[faqIndex][flag.key] = !updatedSubcategories[subcategoryIndex].faqs[faqIndex][flag.key];
                                          setSubcategories(updatedSubcategories);
                                          checkDropdownValidity();
                                        }}
                                        disabled={editMode === true && editSubCategoryId !== subcategory.id}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            {/* </div>
                          <div className="mt-2 p-3"> */}
                            <div className="d-flex justify-content-between">
                              <div className="w-100 p-3">
                                <div className="mb-4">
                                  <div className="row">
                                    <h5>Assignees</h5>
                                    {faq?.assignees?.map(
                                      (assignee, assigneeIndex) => (
                                        <div
                                          className="col-md-4 mb-3"
                                          key={assigneeIndex}
                                        >
                                          <Form.Group>
                                            <div className="d-flex">
                                              <div style={{ display: "flex", flexDirection: "column" }}>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Assignees"
                                                  defaultValue={assignee?.email}
                                                  onChange={(event) => handleFAQAssigneeChange(event, subcategoryIndex, faqIndex, assigneeIndex)}
                                                />
                                              </div>
                                              <Button
                                                variant="danger"
                                                onClick={() => handleFAQDeleteAssignee(assignee, subcategoryIndex, faqIndex, assigneeIndex)}
                                                disabled={editMode === true && editSubCategoryId !== subcategory.id}
                                              >
                                                <FaMinusCircle />
                                              </Button>
                                            </div>
                                          </Form.Group>
                                        </div>
                                      )
                                    )}
                                    {faq?.assignees?.length === 0 && (
                                      <div className="col-md-4 mb-3">
                                        <Button
                                          disabled={editMode === true && editSubCategoryId !== subcategory.id}
                                          onClick={() => handleFAQAddAssignee(subcategoryIndex, faqIndex)}
                                        >
                                          Add Assignee
                                        </Button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                      <div className="p-3">
                        <Button
                          onClick={() => handleAddFAQ(subcategoryIndex)}
                          disabled={editMode === true && editSubCategoryId !== subcategory.id}
                        >
                          Add FAQ
                        </Button>
                      </div>
                    </>
                  )}
                  <div className="d-flex align-items-center">
                    <h5 className="p-3">Enable Reasons</h5>
                    <div className="p-3">
                      <Form.Check
                        type="switch"
                        id="reason-toggle"
                        checked={subcategory?.reasons_flag} // you'd have a separate state like showFAQ for reasons
                        onChange={() => {
                          const newShowReasons = !showReasons;
                          setShowReasons(newShowReasons);
                          const updatedSubcategories = [...subcategories];
                          updatedSubcategories[subcategoryIndex].reasons_flag = newShowReasons;
                          setSubcategories(updatedSubcategories);
                        }}
                        disabled={editMode === true && editSubCategoryId !== subcategory.id}
                      />
                    </div>
                  </div>

                  {(showReasons || subcategory?.reasons_flag) && (
                    <>
                      {subcategory?.reasons?.map((reason, reasonIndex) => (
                        <div key={reasonIndex}>
                          {/* Display Reason */}
                          <div className="d-flex align-items-center">
                            <Form.Label className="w-25 p-2">
                              Reason {reasonIndex + 1}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={reason?.label}
                              onChange={(event) => handleChange("reason", event, subcategoryIndex, reasonIndex)}
                              disabled={editMode === true && editSubCategoryId !== subcategory.id}
                            />

                            <DeleteButton
                              type="reason"
                              subcategoryIndex={subcategoryIndex}
                              itemIndex={reasonIndex}
                              className="ml-2"
                            />
                            {editMode && (
                              <>
                                <Button
                                  variant="danger"
                                  onClick={() => handleDeleteReasons(reason, subcategory)}
                                  disabled={!isCategoryValid || !isSubCategoryValid || !isAssigneeValid}
                                >
                                  <FaMinusCircle />
                                </Button>
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                      <div className="p-3">
                        <Button
                          onClick={() => handleAddReason(subcategoryIndex)}
                          disabled={editMode === true && editSubCategoryId !== subcategory.id}
                        >
                          Add Reason
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>

          <Button
            variant="success"
            onClick={handleAddSubcategory}
            className="mt-2"
          >
            + Subcategory
          </Button>
        </div>
        <Button
          variant="primary"
          type="button"
          onClick={editMode ? handleClose : handleSubmit}
          className="m-2"
          disabled={editMode ? false : !isFormValid || !isDropdownValid}
        >
          {editMode ? "Close" : "Submit"}
        </Button>
      </Form>
    </div>
  );
};

export default TicketingSettings;
